<kendo-dialog [width]="530" [maxHeight]="'90vh'"
    [height]="'auto'" (close)="closeDialog()" id="iep-close-confirmation" (click)="$event.stopPropagation()">
  <kendo-dialog-titlebar><kendo-svg-icon [icon]="warningTriangleIcon" [themeColor]="'error'" size="xlarge"
      title="Warning" class="k-mr-3"></kendo-svg-icon>
    Confirm</kendo-dialog-titlebar>
<section class="k-d-grid k-gap-y-md">
  <div>
    <p class="!k-m-0">Are you sure you want to proceed?</p>
  </div>
    <div>
      <p class="k-text-error !k-font-bold">
        Warning: This action is irreversible. Once confirmed, the student's
        status will be updated to <b>IEP Closed</b>.
      </p>
    </div>
</section>
  <kendo-dialog-actions>
    <button kendoButton themeColor="primary" (click)="onClickBack()">No, Go Back</button>
    <button kendoButton themeColor="error" fillMode="flat" (click)="onConfirm()">
      Yes, Confirm
    </button>
  </kendo-dialog-actions>
</kendo-dialog>